<template>
  <div class="box-card">
    
      <el-row :gutter="12">
        <el-col :span="19">
          <span class="title">{{$t('message.title.importgeneralBOM')}}</span>
        </el-col>
        <el-col :span="4">
          <el-steps :active="active" finish-status="success" size='mini'>
            <el-step></el-step>
            <el-step></el-step>
            <el-step></el-step>
          </el-steps>
        </el-col>
        <el-col style="margin-bottom: -20px;">
          <el-divider></el-divider>
        </el-col>
        <el-col>
          <el-carousel ref="carousel" class="content" arrow="never" indicator-position="none" :autoplay="autop">
            <el-carousel-item class="item">
              <TableModel ref="table"></TableModel>

              <!-- <el-row style="margin-top: 70px; height: 240px">
                <el-col :span="15" :offset=5 style="font-weight: 600">
                  <span>{{$t('message.title.fileModel')+' : '}}</span>
                  <el-cascader ref='subSelect' size="small" class="input-model" v-model="value" :options="options" @change="selectType" clearable="">
                  </el-cascader>
                </el-col>
                <el-col :span="15" :offset=5 style="margin-top:15px">
                  <span>{{$t('message.tips.tip')+' : '}}</span>{{$t('message.tips.exportModel')}}
                </el-col>
              </el-row>
              <vxe-grid v-show="tableShow" ref="xTable" v-bind="addTableList">
              </vxe-grid> -->
              <el-row style="margin-top:15px">
                <el-col :span="6" :offset="18">
                  <div style="width: 200px; overflow: hidden">
                    <el-button size="small" @click="next" >{{$t('message.button.next')}}</el-button>
                    <el-button type="primary" size="small" style="margin-left: 5px" @click="exportDataEvent" >{{$t('message.button.exportModel')}}</el-button>
                  </div>
                </el-col>
              </el-row>
            </el-carousel-item>
            <el-carousel-item style="height:560px" v-if = 'systemName.indexOf("奥斯汀") == -1'>
            <!-- <el-carousel-item style="height:560px" v-if = 'systemName.indexOf("taylor") != -1'> -->
              <div class="model lastPage">
                <el-row>
                  <el-col :span="21" :offset="1">
                    <add-change  @getChangeInfo="addList" @listDbClick="addList" :baseId='baseId'></add-change>
                  </el-col>
                </el-row>
                <el-row >
                  <el-col :span="6" :offset="16">
                    <el-button size="small" @click="next" :disabled="!changeId" >{{$t('message.button.next')}}</el-button>
                    <el-button size="small" @click="cancel">{{$t('message.button.cancel')}}</el-button>
                  </el-col>
                </el-row>
              </div>
            </el-carousel-item>
            <el-carousel-item style="height:560px">
              <div class="model lastPage">
                <el-row>
                  <el-col :span="16" :offset="5">
                    <el-upload class="upload-demo" action="" :show-file-list="false" :before-upload="importFile">
                      <span style="display: inline-blcok">{{$t('message.title.fileImport')}}:</span>
                      <el-button size="small" type="primary" style="margin-left: 5px">{{$t('message.button.toImport')}}</el-button>
                      <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
                    </el-upload>
                  </el-col>
                </el-row>
                <el-row style="margin-top:280px">
                  <el-col :span="6" :offset="16">
                    <el-button size="small" @click="cancel">{{$t('message.button.cancel')}}</el-button>
                  </el-col>
                </el-row>
              </div>
              <!-- <div class="model">
                <el-upload
                  class="upload-demo"
                  action=""
                  :show-file-list="false"
                  :before-upload="importFile"
                >
                  <span style="display: inline-blcok">文件上传:</span>
                  <el-button
                    size="small"
                    type="primary"
                    style="margin-left: 5px"
                    >点击上传</el-button
                  > -->
              <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
              <!-- </el-upload>
              </div> -->
              
            </el-carousel-item>
            <el-carousel-item style="height:560px" >
              <div class="model lastPage">
                <div style="height:40px;position:relative">
                  <li v-for="item in fileInfo" class="file-info" :key="item.id">
                    <div class="table-list">
                      <span class="list-key-1">{{ item.name }} :</span>
                      <!-- <span style="display: inline-block; margin: 0 6px">:</span> -->
                      <span class="list-val" :title="item.val">{{
                        item.val
                      }}</span>
                    </div>
                  </li>
                </div>
                <div style="height:400px;overflow-y:auto;position:relative" :class='{tableHide:!tableShow}'>
                  <!-- <p>该文档出现以下 <span>{{errorImport ? '错误':'异常'}}</span></p> -->
                  <el-table :data="msgInfo" height="390" style="width: 100%">
                    <el-table-column prop="msg" :label = 'msgTitle'>
                    </el-table-column>
                  </el-table>
                  <!-- <li v-for="item in msgInfo" class="file-info" :key="item.id">
                    <div class="table-list">
                      <span class="list-val" :title="item">{{
                        item
                      }}</span>
                    </div>
                  </li> -->
                </div>
                <el-row style="margin-top:15px">
                  <el-col :span="6" :offset="16">
                    <el-button type="primary" size="small" @click="conti" v-if="continueImport">继续上传</el-button>                  
                    <el-button size="small" @click="cancel" v-if="errorImport || continueImport ">{{$t('message.button.cancel')}}</el-button>
                    <el-button type="primary" size="small" @click="done" v-if="successImport">{{$t('message.title.finish')}}</el-button>
                  </el-col>
                </el-row>
              </div>
            </el-carousel-item>
          </el-carousel>
        </el-col>
      </el-row>
  </div>
</template>

<script>
import  addChange from '@/components/relSearchAdd.vue';
import axios from "axios";
export default {
  data() {
    return {
      // options: [],
      tableShow: false,
      value: "",
      subClass: "",
      active: 0,
      autop: false,
      isSelect: false,
      addTableList: {
        columns: [],
      },
      baseId:104,
      changeId:'',
      systemName:'',
      fileInfo: [],
      msgInfo:[],
      msgTitle:'',
      continueImport:false,
      errorImport:false,
      successImport:false
    };
  },
  components: {
    TableModel: () => import("./table/tableModel.vue"),
    addChange
  },
  // components:['TableModel'],
  methods: {
    getTable(e) {
      console.log(e);
      if (e.length) {
        let obj = {
          baseId: 1,
          classId: 1,
          subClassId: e[2],
        };
        let url = `/pmdm/importTemplate/getImportTemplate${this.params(obj)}`;
        axios.post(url).then((res) => {
          let n = Object.values(res.data.object.fieldList);
          // console.log(n);
          // // n[0].id = n[0].id - 1;
          // console.log(n);
          this.addTableList.columns = n.map((i) => {
            return { field: i.id, title: i.name };
          });
        });
      }
    },
    selectType(e) {
      this.isSelect = Boolean(e.length);
      this.getTable(e);
    },

    addList(arr) { //添加
      // console.log(row);
      let row = arr[0];
      console.log(row);
      this.changeId = row.itemId;
    },
    
    importFile(file) {
      // console.log(file);
      // this.filePro = file;
      let obj_name = {};
      obj_name.name = this.$t("message.title.fileName");
      obj_name.val = file["name"];
      let obj_time = {};
      obj_time.name = this.$t("message.title.importDate");
      obj_time.val = this.formatDate(file["lastModified"]);

      this.fileInfo = [obj_name];

      let fd = new FormData();
      fd.append("file", file);
      fd.append("changeId", this.changeId);

      fd.append("isImport", 'false');
      fd.append("BOMList", JSON.stringify([]));

      // let url = this.urlList.filter(i => {return i.baseId == this.value[0]})[0].url
      // console.log(url);
      axios.post("/pmdm/import/importCommonBoms", fd).then((res) => {
        // console.log(res);
        if (res.data.code == 200) {
          
          let m = res.data.object;
          console.log(m);
          this.BOMList = m.BOMList;
          this.msgInfo = m.errorList.length ? m.errorList : m.warningList.length ? m.warningList : [];
          this.msgTitle = m.errorList.length ? '文档错误列表' : '文档警告列表'

          this.tableShow = !!this.msgInfo.length;

          this.msgInfo = this.msgInfo.map(i =>({'msg':i}));

          this.errorImport = !!m.errorList.length
          this.continueImport = !!m.warningList.length && !m.errorList.length
          this.successImport = !m.errorList.length && !m.warningList.length
          
          // console.log(this.fileInfo);
          if (!this.msgInfo.length) {
            let n = Object.keys(m.infoMap).map((i, e) => {
              return {
                name: i,
                val: Object.values(m.infoMap)[e],
              };
            });
            this.fileInfo = [...this.fileInfo,...n];
            console.log(this.fileInfo);
          }
          this.next();
        } 
      });
    },
    next() {
      this.$refs.carousel.next();
      this.active++;
    },
    cancel() {
      this.$refs.carousel.prev();
      this.active--;
    },
    conti(){
      const obj = {BOMList:this.BOMList,changeId:this.changeId}
      axios.post("/pmdm/import/importBomsByList", obj)
      .then(res =>{        
        if (res.data.code == 200) {
          this.$message({
            message: res.data.message,
            type: "success",
          });
          this.successImport = true;
          this.continueImport = false;
          this.msgInfo = [];
          this.tableShow = false
          let m = res.data.object;
          let n = Object.keys(m).map((i, e) => {
            return {
              name: i,
              val: Object.values(m)[e],
            };
          });
          this.fileInfo = [...this.fileInfo,...n]
        }
      })
    },
    downLoad() {
      //  console.log(this.value.length);
    },
    exportDataEvent() {
      this.$refs.table.getSelectEvent();
    },
    // async getInfo() {
    //   const { data: res } = await this.$http.get(
    //     "/pmdm/admin/getClassListNewStyle"
    //   );
    //   this.options = res.object.clsList.filter((i) => i.value == 101);
    // },
    done() {
      this.$emit("deletePage", "/importBoms");
    },
    formatDate(date) {
      var date = new Date(date);
      var YY = date.getFullYear() + "-";
      var MM =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hh =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var mm =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      var ss =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return YY + MM + DD + " " + hh + mm + ss;
    },
  },
  created() {
    this.systemName = window.sessionStorage.getItem("systemName");
  },
};
</script>
<style >

</style>
<style scoped>
.box-card {
  /* width: 100%; */
  /* height: 780px; */
  padding: 20px;
  background: #fff;
}
.tableHide{
  visibility: hidden;
}
.content {
  width: 96%;
  height: 740px;
}
.item {
  height: 740px;
}
.file-info {
  margin-left: 80px;
  text-align: left;
  height: 40px;
  line-height: 40px;
  width: 78%;
  border-bottom: solid 1px #ddd ;
}
.list-val {
  margin-left: 5px;
}
.model {
  margin-top: 25px;
  margin-left: 120px;
  /* text-align: center; */
  height: 640px;
  padding-top: 45px;
}
.model.lastPage{
  /* margin-top: 25px;
  margin-left: 20px;
  text-align: center;
  height: 460px;
  padding-top: 25px; */
}
.input-model {
  margin-left: 5px;
  width: 36%;
}
.next-click {
  margin-left: 540px;
  text-align: center;
  overflow: hidden;
  width: 160px;
  /* float: right;
    margin-top: 140px;
    margin-left: 120px; */
}
.title {
  border-left: 8px solid #3ea0fb;
  padding-left: 12px;
  font-size: 18px;
  height: 18px;
  line-height: 18px;
}
</style>